import React, { Component } from 'react';
import { Button, Modal, Form, Input } from 'semantic-ui-react';

const propTypes = {};

const defaultProps = {};

class ChangeMyPWD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prePassword: null,
      chgPassword1: null,
      chgPassword2: null
    };
  }

  componentWillReceiveProps() {
    this.setState({
      prePassword: null,
      chgPassword1: null,
      chgPassword2: null
    });
  }

  handlePrePwdEvent = (e, data) => {
    this.setState({
      prePassword: data.value
    });
  };

  handleChgPwd1Event = (e, data) => {
    this.setState({
      chgPassword1: data.value
    });
  };

  handleChgPwd2Event = (e, data) => {
    this.setState({
      chgPassword2: data.value
    });
  };

  render() {
    const { open, size, closeFn, okFn } = this.props;
    const { prePassword, chgPassword1, chgPassword2 } = this.state;

    return (
      <Modal className="change-pwd-mod" size={size} open={open} onClose={(e) => closeFn(false, 'small')}>
        <Modal.Header>비밀번호 재설정</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field inline>
              <label>현재 비밀번호</label>
              <Input type="password" placeholder="현재 비밀번호" min="1" max="20" maxLength={20} onChange={this.handlePrePwdEvent} />
            </Form.Field>
            <Form.Field inline>
              <label>변경할 비밀번호</label>
              <Input
                type="password"
                placeholder="변경할 비밀번호"
                min="1"
                max="20"
                maxLength={20}
                onChange={this.handleChgPwd1Event}
              />
            </Form.Field>
            <Form.Field inline>
              <label>변경할 비밀번호 재입력</label>
              <Input
                type="password"
                placeholder="변경할 비밀번호 재입력"
                min="1"
                max="20"
                maxLength={20}
                onChange={this.handleChgPwd2Event}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button className="cancel" inverted color="grey" onClick={(e) => closeFn(false, '')}>
            취소
          </Button>
          <Button
            className="ok"
            color="green"
            onClick={(e) => okFn(prePassword, chgPassword1, chgPassword2)}
            content="완료"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

ChangeMyPWD.propTypes = propTypes;
ChangeMyPWD.defaultProps = defaultProps;

export default ChangeMyPWD;
